module.exports = __webpack_public_path__ + "img/sheremetevo@2x.522d716f.png";